// Placeholder — per-friend profile page (their nights with you, shared bars,
// damage delta) is a follow-up. Stub keeps friend-card taps from 404ing.

import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { BackButton, TopBar } from '../../components/TopBar'

export const Route = createFileRoute('/your-people/$friendId')({
  component: FriendStub,
})

function FriendStub() {
  const navigate = useNavigate()
  return (
    <div className="stumble-screen">
      <TopBar
        left={<BackButton onClick={() => navigate({ to: '/your-people' })} />}
        eyebrow="coming soon"
        title="friend profile"
      />
      <div
        className="screen-body"
        style={{ display: 'grid', placeItems: 'center', textAlign: 'center', gap: 8 }}
      >
        <p className="display" style={{ fontSize: 32 }}>
          their nights, your nights.
        </p>
        <p className="body-sm muted">Shared bars + damage delta in the next drop.</p>
      </div>
    </div>
  )
}
